import Pipeline from "../Pipeline";
import { UserActionReportRsp } from "../actionTypes";
import { ITransport, Action, ActionType, ActionResult } from "../types";
import XHRTransport from "./XHRTransport";

export default class Transport extends Pipeline<Action> implements ITransport {
    private xhrTransport: XHRTransport;

    constructor() {
        super();

        this.xhrTransport = new XHRTransport();
    }

    process(action: Action): Promise<ActionResult<UserActionReportRsp>> {
        if (action === null) {
            return null;
        }

        if (action.type === ActionType.SDK) {
            return this.xhrTransport.send(action);
        }

        return null;
    }
}
